import { render, staticRenderFns } from "./ActivateReportContactForm.vue?vue&type=template&id=7770b3a6&scoped=true&"
import script from "./ActivateReportContactForm.vue?vue&type=script&lang=js&"
export * from "./ActivateReportContactForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivateReportContactForm.vue?vue&type=style&index=0&id=7770b3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7770b3a6",
  null
  
)

export default component.exports